<template>
  <b-container fluid class="survey-container position-relative">
    <div class="top-right">
      <a ref="closePage" href="musicverse://survey_done" class="close-page d-flex justify-content-center align-items-center">
        <font-awesome-icon :icon="['fa', 'times']" class="icon-close" />
      </a>
      <div class="survey-info" v-if="!isDone">
        <span>{{indexQuestion+1}}</span>
        <span class="mx-1">of</span>
        <span>{{listQuestion.length}}</span>
      </div>
    </div>
    <div class="survey-content" v-if="!isDone">
      <h1 class="survey-title">{{questionTitle}}</h1>
      <p class="survey-question">{{questionText}}</p>
      <small class="survey-hint">Select a max of 3 choices only</small>
      <ul class="survey-option-list">
        <template v-if="listQuestion.length>0">
          <li v-for="(opt, index) in listOption">
            <div class="custom-control custom-checkbox option-checkbox">
              <input type="checkbox" class="custom-control-input" :key="index" :id="'check-'+index" :value="opt" v-model="selectedOptions" >
              <label class="custom-control-label option-label" :for="'check-'+index" >{{opt.text}}</label>
            </div>
          </li>
        </template>
        <li v-if="showTextArea">
          <textarea class="form-control custom-textarea" v-model="customValue" placeholder="Type your answer"></textarea>
        </li>
      </ul>
      <button class="btn btn-block" v-bind:class="{'btn-primary': canSubmit,  'btn-secondary': !canSubmit}" @click="next">Next</button>
    </div>
    <div class="survey-success" v-if="isDone">
<!--      <div class="success-image w-100 d-flex justify-content-center">-->
<!--        <img src="@/assets/survey-success.png" alt="" />-->
<!--      </div>-->
      <h1 class="success-title">Thank You for Participating in Our Survey</h1>
      <p class="success-info">Thank you for taking the time to complete this survey. Your feedback will definitely assist us in making MusicVerse a super app that meets the daily needs of Adventists. Take care and God bless!</p>
      <a href="musicverse://survey_done" class="btn btn-primary btn-block" >Back to Home</a>
    </div>

  </b-container>

</template>

<script>
import Vue from "vue";
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "SurveyPage",
  data() {
    return {
      listQuestion:[],
      listOption:[],
      indexQuestion:0,
      isDone: false,
      selectedOptions:[],
      questionTitle:"",
      questionText:"",
      customValue: ""
    }
  },
  async mounted(){
    await this.requestListSurveyQuestions();
  },
  computed:{
    ...mapGetters('SurveyModule', ['listSurveyQuestion']),
    ...mapGetters('NotificationModule', ['getLoading', 'getStatus', 'getMessage', 'getErrorCode']),
    canSubmit(){
      const lengthSelected = this.selectedOptions.length;
      return lengthSelected!==0 && lengthSelected<=3;
    },
    showTextArea(){
      if(this.listOption.length>0){
        const lastOption = this.listOption[this.listOption.length-1].text;
        const filter = this.selectedOptions.filter((opt) => {
          return lastOption === opt.text;
        })
        return filter.length>0;
      }
      return false;
    }
  },
  watch: {
    listSurveyQuestion: {
      immediate: true,
      deep: true,
      async handler(val) {
        if(this.listSurveyQuestion.length>0){
          this.listQuestion = Object.assign([],this.listSurveyQuestion);
          this.indexQuestion = 0;
          this.questionText = this.listQuestion[this.indexQuestion].question;
          this.questionTitle = this.listQuestion[this.indexQuestion].title;
          this.listOption = Object.assign([],this.listQuestion[this.indexQuestion].option.map((opt,index) => {
            return {
              index:index,
              text:opt.value,
              value:true
            }
          }))
        }
      }
    }
  },
  methods: {
    ...mapActions('SurveyModule', ['requestListSurveyQuestions','requestSubmitSurvey']),
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    async next(){
      const lengthSelected = this.selectedOptions.length;
      if(lengthSelected!==0 && lengthSelected<=3){
        let selectedData = Object.assign([],this.selectedOptions.map((s)=>{
          return {
            text:s.text,
            value:s.value,
            index:s.index,
          }
        }))
        if(this.customValue!==''){
          const lastOptionText = this.getLastOptionText();
          const customValue = this.customValue;
          selectedData = selectedData.map((sd)=>{
            sd.value = sd.text === lastOptionText?customValue:true
            return sd;
          })
        }
        selectedData.sort((a, b) => {
          return a.index - b.index
        })
        this.listQuestion[this.indexQuestion]['answers'] = Object.assign([],selectedData);
        this.selectedOptions = Object.assign([],[]);
        this.customValue = '';
        if(this.listQuestion.length > this.indexQuestion+1){
          this.indexQuestion += 1;
          this.questionText = this.listQuestion[this.indexQuestion].question;
          this.questionTitle = this.listQuestion[this.indexQuestion].title;
          this.listOption = Object.assign([],this.listQuestion[this.indexQuestion].option.map((opt,index) => {
            return {
              index:index,
              text:opt.value,
              value:true
            }
          }))
        }else{
          const data = this.listQuestion.map((q) => {
            const feedback = q.answers.map((opt)=>{
              return {
                option:opt.text,
                value: opt.value
              }
            })
            return {
              id:q.id,
              feedback:feedback,
            }
          });
          await this.requestSubmitSurvey({data});
          this.isDone = true;
        }
      }
    },
    getLastOptionText(){
      return this.listOption[this.listOption.length-1].text;
    }
  }
}
</script>

<style scoped>
  .survey-container{
    padding:24px;
    text-align: left;
    min-height: 100vh;
    overflow-y: auto;
  }
  .top-right{
    position: absolute;
    top:24px;
    right:24px;
    display: flex;
    flex-direction: column;
  }
  .close-page{
    width: 44px;
    height: 44px;
    background: rgba(60, 60, 67, 0.18);
    border-radius: 8px;
    margin-bottom: 12px;
  }
  .icon-close{
    color: #000000;
    font-size: 1.5rem;
  }
  .survey-info{
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #999999;
  }
  .survey-title{
    font-weight: 400;
    font-size: 30px;
    line-height: 36px;
    color: #2C6CB5;
    margin-top:56px;
    margin-bottom:24px;
  }
  .survey-question{
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: #000000;
    margin-bottom: 0;
  }
  .survey-hint{
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #999999;
  }
  .survey-option-list{
    margin-top: 24px;
    margin-bottom: 40px;
    list-style: none;
    display: flex;
    flex-direction: column;
    padding: 0;
  }
  .survey-option-list li{
    display: flex;
    margin-bottom: 12px;
  }
  .option-checkbox{
    display: flex;
    margin-left: 0.5rem;
  }
  .option-label{
    font-size: 14px;
    line-height: 17px;
    color: #000000;
  }
  .option-label::before{
    border: #000000 solid 2px;
    top: 0;
    left: -2rem;
    width: 14px;
    height: 14px;
    border-radius: 0;
  }
  .option-label::after{
    top: 0;
    left: -2rem;
    width: 14px;
    height: 14px;
  }
  .option-checkbox .custom-control-input:checked ~ .option-label::after{
    background-color: #32D74B;
  }
  .custom-textarea{
    border: 1px solid #C7C7CC;
    border-radius: 10px;
    height: 202px;
    resize:none;
  }
  .success-image{
    margin-top: 56px;
    margin-bottom: 24px;
  }
  .success-image img{
    width: 126px;
    height: 128px;
  }
  .success-title{
    font-weight: 400;
    font-size: 30px;
    line-height: 36px;
    color: #2C6CB5;
    margin-bottom: 24px;
    padding-right: 30px;
    margin-top:56px;
  }
  .success-info{
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #000000;
    margin-bottom: 105px;
  }
</style>



// WEBPACK FOOTER //
// src/views/SurveyPage.vue